const prefix = `printOptions:`;

const SET_PRINT_PAPER_SIZE = `${prefix}SET_PRINT_PAPER_SIZE`;
const SET_PRINT_ORIENTATION = `${prefix}SET_PRINT_ORIENTATION`;
const SET_PRINT_SCALE = `${prefix}SET_PRINT_SCALE`;

export const actionTypes = {
  SET_PRINT_PAPER_SIZE,
  SET_PRINT_ORIENTATION,
  SET_PRINT_SCALE
};

const setPrintPaperSize = size => {
  return {
    type: SET_PRINT_PAPER_SIZE,
    size
  };
};

const setPrintOrientation = orientation => {
  return {
    type: SET_PRINT_ORIENTATION,
    orientation
  };
};

const setPrintScale = scale => {
  return {
    type: SET_PRINT_SCALE,
    scale
  };
};

export default {
  setPrintPaperSize,
  setPrintOrientation,
  setPrintScale
};
